<template>
  <div class="mt-4 d-flex align-center">
    <!-- VOLTAR -->
    <v-btn v-if="showBack" text class="mr-3" @click="$emit('back')">
      Voltar
    </v-btn>

    <v-spacer />

    <!-- CONTINUAR -->
    <v-btn
      :color="insurer.color"
      dark
      :disabled="disabled"
      @click="$emit('next')"
    >
      Continuar
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "StepperActions",

  props: {
    insurer: Object,

    showBack: {
      type: Boolean,
      default: true,
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
